<template>
    <van-col
        :span="span"
        :flex="flex"
      
        ref="my"
    >
        <div class="title_col">
            <div style="width:4vw">
                <img
                    v-if="index==0"
                    src="@/assets/warehouse2.png"
                    style="width:3vw;height: 3vw;"
                    alt=""
                >
                <img
                   v-else-if="index==1"
                    src="@/assets/warehouse1.png"
                    style="width:3vw;height: 3vw;"
                    alt=""
                >
                <img
                    v-else-if="index==2"
                    src="@/assets/warehouse4.png"
                    style="width:3vw;height: 3vw;"
                    alt=""
                >
                <img
                    v-else-if="index==3"
                    src="@/assets/warehouse3.png"
                    style="width:3vw;height: 3vw;"
                    alt=""
                >
            </div>
            <div>
                <div class="title"><span>{{title}}</span></div>
                <div class="content">
                    <div>{{value}}</div>
                    <div class="addnumber" v-if="addvalue>0">+{{addvalue}}</div>
                    <div class="addnumber" v-else></div>
                </div>

            </div>
        </div>
    </van-col>
</template>
<script>
export default {
  name: "myvancol",
  props: {
    span: String,
    flex: Number,
    title: {
      type: String,
      default: () => {
        return "你的标题";
      }
    },
    addvalue:Number,
    value: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    index:Number
  },
  data(){
      return{
          
      }
  },
  methods:{
      
  },
  created(){
  },
  mounted(){
  }
};
</script>

<style lang="scss" scoped>
.title_col {
  display: flex;
  background: #171d3f;
  color: #fff;
  min-height: 7vw;
  align-items: center;
  margin-left: 0.5vw;
  padding-left: 0.5vw;
  margin-right: 0.5vw;
  border-radius: 0.4vw;
  margin-top: 1vw;
  .title {
    color: #a6ade0;
    font-size: 1vw;
    padding-left: 0.5vw;
  }
  //   div div:nth-child(2) {

  //   }
  .content {
    font-size: 1.5vw;
    padding-top: 1vw;
    padding-left: 0.5vw;
    color: #ffffff;
    display: flex;

    .addnumber {
      color: #50b0ff;
      font-size: 1vw;
      margin-left: 0.5vw;
      opacity: 0;
       -webkit-animation: fadeInOut  2s infinite ease-in-out alternate;
    
    }
    @-webkit-keyframes fadeInOut  {
      /*透明度由0到1*/
      0% {
        opacity: 1;
      }
      25% {
        opacity: 0;
      }
      50% {
        opacity: 0;
      }
      75% {
        opacity: 1;
      }
    }
  }
}
</style>
